export const findComboItem = (comboData, searchKey) => {
  if (!comboData?.data || !searchKey) return undefined

  return comboData.data.find((item) => item.key.split('|').includes(searchKey.toString()))
}

export const findEstadoByKey = (estadosData, estadoKey) => {
  if (!estadosData?.data || !estadoKey) return undefined

  return estadosData.data.find((estado) => estado.key === estadoKey.toString())
}
